interface IOptions {
    /** Если в ответе есть свойство data - вернется только это свойство */
    unwrapDataProperty: boolean;
}

type TRequestInfo = Parameters<typeof fetch>[0];
type TRequestInit = Parameters<typeof fetch>[1];

export async function _fetch<T>(requestInfo: TRequestInfo, requestInit?: TRequestInit, options?: IOptions) {
    const { unwrapDataProperty = true } = options ?? {};
    const response = await fetch(requestInfo, {
        headers: {
            'Content-Type': 'application/json',
            ...(requestInit?.headers ?? {}),
        },
        ...requestInit,
    });

    const responseContentType = response?.headers?.get('content-type');

    if (responseContentType && ~responseContentType.indexOf('application/json')) {
        const result = await response.json();

        if (unwrapDataProperty && result.data) return result.data as T;

        return result as T;
    }

    return response as T;
}
